import '../styles/loading.css'

export default function Loading({ header = 'Loading...' }) {
  return (
    <div
      class="loading-wrap"
      role="status"
      aria-live="polite"
      aria-label="Laddar"
    >
      <div class="stick-loader">
        <svg viewBox="0 0 240 140" aria-hidden="true">
          {/* <!-- "problem" bubble --> */}
          <g class="problem" transform="translate(165,26)">
            <rect x="0" y="0" rx="10" ry="10" width="54" height="44"></rect>
            <path class="tail" d="M16,44 C10,54 0,56 -8,58"></path>
            <text x="27" y="30" text-anchor="middle">
              ?
            </text>
          </g>

          {/* <!-- stick figure --> */}
          <g class="figure" transform="translate(78,78)">
            {/* <!-- head --> */}
            <circle class="head" cx="0" cy="-32" r="16"></circle>

            {/* <!-- eyes (look at problem) --> */}
            <g class="eyes" transform="translate(0,-34)">
              <circle class="eye" cx="-6" cy="-35" r="2.2"></circle>
              <circle class="eye" cx="6" cy="-35" r="2.2"></circle>
            </g>

            {/* <!-- body --> */}
            <line class="stroke" x1="0" y1="-16" x2="0" y2="30"></line>

            {/* <!-- left arm (down) --> */}
            <g class="arm arm-left">
              <line class="stroke" x1="0" y1="0" x2="-26" y2="10"></line>
              <line class="stroke" x1="-26" y1="10" x2="-38" y2="28"></line>
            </g>

            {/* <!-- right arm (scratching) --> */}
            <g class="arm arm-right" transform="translate(0,-8)">
              {/* <!-- shoulder to elbow --> */}
              <line class="stroke" x1="0" y1="10" x2="18" y2="-8"></line>
              {/* <!-- elbow to hand (near head) --> */}
              <line
                class="stroke forearm"
                x1="18"
                y1="-8"
                x2="16"
                y2="-30"
              ></line>

              {/* <!-- little "scratch" ticks near head --> */}
              <g class="scratch" transform="translate(8,-28)">
                <line class="tick" x1="10" y1="-6" x2="16" y2="-10"></line>
                <line class="tick" x1="12" y1="0" x2="18" y2="-4"></line>
                <line class="tick" x1="8" y1="6" x2="14" y2="2"></line>
              </g>
            </g>

            {/* <!-- legs --> */}
            <g class="legs" transform="translate(0,30)">
              <line class="stroke" x1="0" y1="0" x2="-18" y2="34"></line>
              <line class="stroke" x1="0" y1="0" x2="20" y2="34"></line>
            </g>
          </g>
        </svg>

        <div class="loading-text">
          {header !== '' && <div class="title">{header}</div>}
          <div class="sub">Thinking through the problem</div>
        </div>
      </div>
    </div>
  )
}
